var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-failed d-flex justify-content-center"},[_c('ErrorMessage',{attrs:{"message":_vm.errorMessage == 'no-products' ? _vm.$t(`general.no-products`) : _vm.errorMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }